
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/management-team",
      function () {
        return require("private-next-pages/about/management-team.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/management-team"])
      });
    }
  